import { queryOptions, useQuery } from "@tanstack/react-query";

import { api, call } from "@/core/api/client";
import { ENDPOINTS } from "@/core/api/endpoints";
import { QUERY_KEYS } from "@/core/api/query-client";
import { MY_BRANDS_STALE_MS } from "@/core/constants";

/** The brand teams the signed-in person belongs to, with their role in each. */
export const myBrandsQuery = queryOptions({
  queryKey: QUERY_KEYS.myBrands,
  queryFn: async () => (await call(api.GET(ENDPOINTS.myBrands))).data,
  staleTime: MY_BRANDS_STALE_MS,
});

export function useMyBrands() {
  return useQuery(myBrandsQuery);
}
